import { render, staticRenderFns } from "./AddPacket.vue?vue&type=template&id=65686cc4&lang=pug&"
import script from "./AddPacket.vue?vue&type=script&lang=ts&"
export * from "./AddPacket.vue?vue&type=script&lang=ts&"
import style0 from "./AddPacket.vue?vue&type=style&index=0&id=65686cc4&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports